import $ from 'jquery';
import UI from 'root/ui';
import Cache from 'root/cache';
import Modals from 'root/modals';
import View from 'view/base';

export default View.extend({
    events: {
        'click .row-hover'           : 'onEdit',
        'click .new-screenshot-rule' : 'onCreateScreenshotRule',
        'click .discard-location'    : 'onDiscardLocation',
        'click .account-upgrade'     : 'onAccountUpgrade'
    },

    dom_handlers: {
        onAccountUpgrade: function() {
            Modals.choosePlan();
        },

        onEdit: function(e) {
            var rule_type = $(e.currentTarget).data('rule');
            var rule_id   = $(e.currentTarget).data('id');

            Modals.editRecordingRule(this.model.id, rule_type, rule_id);
        },

        onCreateScreenshotRule: function(e) {
            Modals.addRecordingRule(this.model.id);
        },

        onDiscardLocation: function() {
            this.model.set('discard_location', !this.model.get('discard_location'));

            if (this.model.get('discard_location')) {
                this.$el.find('.discard-location').removeClass('switch-off').addClass('switch-on');
            } else {
                this.$el.find('.discard-location').removeClass('switch-on').addClass('switch-off');
            }

            Cache.app.request({
                action: 'project/discardLocation',
                data : {
                    project_id: this.model.id,
                    discard_location: this.model.get('discard_location')
                },
                success: function(response) {
                    UI.success('User location setting updated.');
                }
            });
        }
    },

    initialize: function(options) {
        this.listenTo(Cache.project_recording_rule, 'add',    this.render);
        this.listenTo(Cache.project_recording_rule, 'remove', this.render);
        this.listenTo(Cache.project_recording_rule, 'change', this.render);
    },

    isLoaded: function() {
        return Cache.project_recording_rule.length || this.is_loaded ? true : false;
    },

    load: function() {
        Cache.app.request({
            action: 'project_recording_rule/get',
            data: {
                project_id: this.model.id
            },
            success: (response) => {
                Cache.project_recording_rule.add(response);
                this.is_loaded = true;
                this.render();
            }
        });
    },

    onPageReady: function() {
        // getting started page update onboarding
        Cache.app.trackOnboarding('privacy_setting_view', '1');
    },

    render: function() {
        if (this.isLoaded()) {
            var rule_block      = Cache.project_recording_rule.findWhere({project_id: this.model.id, rule_type: 'block'});
            var rule_ignore     = Cache.project_recording_rule.findWhere({project_id: this.model.id, rule_type: 'ignore'});
            var rule_mask       = Cache.project_recording_rule.where({project_id: this.model.id, rule_type: 'mask'});
            var rule_screenshot = Cache.project_recording_rule.where({project_id: this.model.id, rule_type: 'screenshot'});

            var rule_mask_selectors = '';
            rule_mask.forEach(function(rule) {
                rule_mask_selectors += '<div class="code-selector">' + rule.get('selector') + '</div>';
            });

            var rule_screenshot_selectors = '';
            rule_screenshot.forEach(function(rule) {
                rule_screenshot_selectors +=
                '<div class="grid-6-6 row-hover padding-top-24 padding-bottom-24 solid-line-bottom" data-rule="screenshot" data-id="' + rule.id + '">' +
                    '<div>' +
                        '<div class="code-selector">' + rule.get('selector') + '</div>' +
                        '<div class="userback-block-sample"></div>' +
                    '</div>' +
                    '<div>' +
                        '<span class="badge-secondary-invert font-weight-medium">Mask</span>' +
                        '<div class="text-info text-small margin-top-4">Matching elements are permanently masked in screenshots.</div>' +
                    '</div>' +
                '</div>';
            });

            var content = '';

            content += '<div class="project-settings-inner-large form-fluid">';

            content += '<div class="field-label">Ignore user location</b></div>' +
                    '<div class="box-small-medium">' +
                        '<div class="grid-10-2">' +
                            '<div><p>When this feature is turned on, Userback will ignore user IP addresses and the location field will be displayed as unknown.</p></div>' +
                            '<div class="text-align-right"><button class="' + (this.model.get('discard_location') ? 'switch-on' : 'switch-off') + ' discard-location small"></button></div>' +
                        '</div>' +
                    '</div>';

            if (Cache.account.hasFeature('privacy_masking')) {
                if (this.model.isFeedback()) {
                    content += '<div class="field-label">Screenshot</div>' +
                            '<div class="box-small-medium">' +
                                '<div class="grid-9-3">' +
                                    '<div><p>Use these settings to control what elements will be masked in the screenshot.</p></div>' +
                                    '<div class="text-align-right"><button class="new-screenshot-rule primary small"><i class="far fa-plus"></i> New Rule</button></div>' +
                                '</div>' +

                                '<div class="divider-12"></div>' +

                                '<div class="grid-6-6 padding-bottom-24 solid-line-bottom">' +
                                    '<div>' +
                                        '<span class="text-info font-weight-medium">Selector</span>' +
                                    '</div>' +
                                    '<div>' +
                                        '<span class="text-info font-weight-medium">Rule</span>' +
                                    '</div>' +
                                '</div>' +

                                (rule_screenshot_selectors ||

                                '<div class="padding-top-24 padding-bottom-24 solid-line-bottom">' +
                                    '<div>' +
                                        '<div class="text-info font-weight-medium italic">empty</div>' +
                                        '<div class="userback-block-sample"></div>' +
                                    '</div>' +
                                '</div>') +
                            '</div>';
                    }

                if (Cache.account.hasFeature('session_recording')) {
                    content += '<div class="field-label">Session Recording</div>' +
                            '<div class="box-small-medium">' +
                                '<p>Use these element recording rules to exclude elements you want to omit from session recording. Mask elements where you want to record user interaction without capturing the text value.</p>' +
                                '<div class="divider-12"></div>' +

                                '<div class="grid-6-6 padding-bottom-24 solid-line-bottom">' +
                                        '<div>' +
                                            '<span class="text-info font-weight-medium">Selector</span>' +
                                        '</div>' +
                                        '<div>' +
                                            '<span class="text-info font-weight-medium">Rule</span>' +
                                        '</div>' +
                                '</div>' +

                                '<div class="grid-6-6 row-hover padding-top-24 padding-bottom-24 solid-line-bottom" data-rule="block">' +
                                        '<div>' +
                                            (rule_block ?
                                            '<div class="code-selector">' + rule_block.get('selector') + '</div>' :
                                            '<div class="text-info font-weight-medium italic">empty</div>') +
                                            '<div class="userback-block-sample"></div>' +
                                        '</div>' +
                                        '<div>' +
                                            '<span class="badge-secondary-invert font-weight-medium">Block</span>' +
                                            '<div class="text-info text-small margin-top-4">For blocked elements, the element itself and its child elements will be completely ignored by recording. All blocked elements are replaced in session replay by rectangles containing diagonal grey and white stripes.</div>' +
                                        '</div>' +
                                '</div>' +

                                '<div class="grid-6-6 row-hover padding-top-24 padding-bottom-24 solid-line-bottom" data-rule="ignore">' +
                                        '<div>' +
                                            (rule_ignore ?
                                            '<div class="code-selector">' + rule_ignore.get('selector') + '</div>' :
                                            '<div class="text-info font-weight-medium italic">empty</div>') +
                                            '<div class="userback-ignore-sample"></div>' +
                                        '</div>' +
                                        '<div>' +
                                            '<span class="badge-secondary-invert font-weight-medium">Ignore</span>' +
                                            '<div class="text-info text-small margin-top-4">For sensitive input fields that your team would like to ignore user input for, you can use the ignore rule that will preserve the styling of the input elements, but ignore all the user inputs.</div>' +
                                        '</div>' +
                                '</div>' +

                                '<div class="grid-6-6 row-hover padding-top-24 padding-bottom-24 solid-line-bottom" data-rule="mask">' +
                                        '<div>' +
                                            (rule_mask_selectors || '<div class="text-info font-weight-medium italic">empty</div>') +
                                            '<div class="userback-mask-sample"></div>' +
                                        '</div>' +
                                        '<div>' +
                                            '<span class="badge-secondary-invert font-weight-medium">Mask</span>' +
                                            '<div class="text-info text-small margin-top-4">For masked elements containing text, all text will be replaced by irreversibly-transformed placeholder text, meant to resemble a wireframe of the original content.</div>' +
                                        '</div>' +
                                '</div>' +
                            '</div>';
                }
            } else {
                content +=
                '<div class="field-label">Data masking</div>' +
                '<div class="box-small-medium">' +
                    '<p>Exclude elements (e.g. credit card forms) you want to mask from screenshots or session recordings. <a class="primary font-weight-medium" href="https://support.userback.io/en/articles/5209239-configure-your-project-settings#h_a2ef634d1e" target="help" rel="noopener">Learn more <i class="fa-solid fa-square-arrow-up-right"></i></a></p>' +
                    '<div class="browser-window-light"><img width="100%" src="/image/privacy_masking.png"></div>' +
                    '<div class="text-align-center margin-top-16">' +
                        '<button class="account-upgrade medium shiny"><span>Upgrade my plan</span></button>' +
                    '</div>' +
                '</div>';
            }

            content += '</div>';

            this.$el.html(content);
        } else {
            var content =
            '<div class="project-settings-inner-large">' +
                '<div class="loader-placeholder margin-bottom-8"></div>' +
                '<div class="loader-placeholder margin-bottom-8"></div>' +
                '<div class="loader-placeholder"></div>' +
            '</div>';

            this.$el.html(content);
            this.load();
        }

        return this;
    }
});